<script>
import TabNav from './tab-nav';

export default {
  name: 'RtTabs',

  deprecatedNames: ['RtContentTabs'],

  components: {
    TabNav
  },

  props: {
    /**
     * @public 1.配置最大字符数标签页模式下的字符长度超出显示省略号默认字符长度
     */
    maxLength: Number,
    /**
     * @public 2.按钮标签模式下的borderRadius-设计稿默认为15px
     */
    borderRadius: {
      type: Number,
      default: 15
    },
    /**
     * @public 3.spacing标签左右外间距支持"button-card"-"spacing-card"两种类型按钮类型
     */
    spacing: Number,
    /**
     * @public 4.padding标签左右内间距仅支持"spacing-card"一种类型按钮类型
     */
    padding: Number,

    type: String,
    activeName: String,

    // 按钮标签页背景 n-primary -primary
    tabButtonBg: String,

    // 标签文字颜色
    tabTextColor: String,

    // 标签是否可关闭
    closable: Boolean,
    // 标签是否可增加
    addable: Boolean,
    // eslint-disable-next-line vue/require-prop-types
    value: {},
    // 标签是否同时可增加和关闭
    editable: Boolean,
    tabPosition: {
      type: String,
      default: 'top'
    },
    // 对齐方式
    tabAlign: {
      type: String,
      default: 'left'
    },
    beforeLeave: Function,
    stretch: Boolean,
    // 标签背景主题颜色
    tabBgcolor: String,
    // 标签自定义边框颜色
    tabBordercolor: String,
    // 标签自定义选中状态背景颜色
    activeBgcolor: String,
    // 标签自定义选中状态边框颜色
    activeBordercolor: String,
    // 标签页大小，默认 medium
    size: {
      type: String,
      default: 'medium'
    },
    // 是否隐藏底部边框
    border: {
      type: Boolean,
      default: true
    },
    // tab bar 上额外的元素
    extraPosition: String,
    // tabPane的padding
    tabPanePadding: String,
    secondary: Boolean, // 二级的 tabs
    tabHeight: {
      type: String,
      default: function () {
        return this.type === 'button-card' ? '31px' : 'auto';
      }
    }
  },

  provide () {
    return {
      rootTabs: this
    };
  },

  data () {
    return {
      currentName: this.value || this.activeName,
      panes: [],
      isDeprecated: false
    };
  },

  watch: {
    activeName (value) {
      this.setCurrentName(value);
    },
    value (value) {
      this.setCurrentName(value);
      this.$nextTick(() => {
        let dom = [
          ...document.querySelectorAll('.is-secondary .rt-tabs__item.is-active')
        ];
        dom.map(item => {
          if (item.clientWidth > 0) {
            item.parentElement.firstElementChild.style.width =
              item.clientWidth + 'px';
          }
        });
      });
    },
    currentName (value) {
      if (this.$refs.nav) {
        this.$nextTick(() => {
          this.$refs.nav.$nextTick(_ => {
            this.$refs.nav.scrollToActiveTab();
          });
        });
      }
    }
  },

  created () {
    if (!this.currentName) {
      this.setCurrentName('0');
    }

    this.$on('tab-nav-update', this.calcPaneInstances.bind(null, true));
  },

  mounted () {
    this.calcPaneInstances();

    this.$on('edit', this.calcPaneInstances.bind(null, true), 'add');
    this.$on('tab-add', this.calcPaneInstances.bind(null, true));
  },

  updated () {
    this.calcPaneInstances();
  },

  methods: {
    /**
     * @private
     *
     * 由boundaryAccessPlugin进行调用
     */
    _deprecatedWarning () {
      if (this.$options._componentTag.endsWith('-content-tabs')) {
        this.isDeprecated = true;

        console.warn(
          'message from xpc: [rt-content-tabs] is deprecated, please use [rt-tabs] instead'
        );
      }
    },

    calcPaneInstances (isForceUpdate = false) {
      if (this.$slots.default) {
        const paneSlots = this.$slots.default.filter(vnode => {
          return (
            vnode.tag &&
            vnode.componentOptions &&
            vnode.componentOptions.Ctor.options.name === 'RtTabPane'
          );
        });

        // update indeed
        const panes = paneSlots.map(
          ({ componentInstance }) => componentInstance
        );
        const panesChanged = !(
          panes.length === this.panes.length &&
          panes.every((pane, index) => pane === this.panes[index])
        );
        if (isForceUpdate || panesChanged) {
          this.panes = panes;
        }
      } else if (this.panes.length !== 0) {
        this.panes = [];
      }
    },
    handleTabClick (tab, tabName, event) {
      if (tab.disabled) return;

      this.setCurrentName(tabName);
      this.$emit('tab-click', tab, event);
    },
    handleTabRemove (pane, ev) {
      if (pane.disabled) return;
      ev.stopPropagation();
      this.$emit('edit', pane.name, 'remove');
      this.$emit('tab-remove', pane.name);
    },
    handleTabAdd () {
      this.$emit('edit', null, 'add');
      this.$emit('tab-add');
    },
    setCurrentName (value) {
      const changeCurrentName = () => {
        this.currentName = value;
        this.$emit('input', value);
      };
      if (this.currentName !== value && this.beforeLeave) {
        const before = this.beforeLeave(value, this.currentName);
        if (before && before.then) {
          before.then(
            () => {
              changeCurrentName();
              this.$refs.nav && this.$refs.nav.removeFocus();
            },
            () => {
              // https://github.com/ElemeFE/element/pull/14816
              // ignore promise rejection in `before-leave` hook
            }
          );
        } else if (before !== false) {
          changeCurrentName();
        }
      } else {
        changeCurrentName();
      }
    }
  },

  render (h) {
    let {
      type,
      handleTabClick,
      handleTabRemove,
      currentName,
      panes,
      editable,
      tabPosition,
      tabAlign,
      stretch,
      size,
      border,
      secondary,
      extraPosition,
      isDeprecated,
      tabHeight
    } = this;

    const navData = {
      props: {
        currentName,
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove,
        editable,
        type,
        panes,
        stretch,
        size,
        border,
        secondary,
        extraPosition
      },
      ref: 'nav'
    };
    const header = (
      <div
        class={[
          'rt-tabs__header',
          'el-tabs__header',
          `is-${tabPosition}`,
          `is-${tabPosition}-${tabAlign}`,
          `is-${size}`,
          border ? 'is-border' : 'no-border',
          isDeprecated ? 'no-border' : '',
          secondary ? 'is-secondary' : ''
        ]}
        style={{ 'height': tabHeight.includes('px') ? tabHeight : tabHeight + 'px' }}
      >
        <tab-nav {...navData}></tab-nav>
      </div>
    );

    const panels = (
      <div class={['rt-tabs__content', 'el-tabs__content']}>
        {this.$slots.default}
      </div>
    );

    return (
      <div
        class={{
          'rt-tabs': true,
          'el-tabs': true,
          'rt-tabs--card': type === 'card',
          'el-tabs--card': type === 'card',
          'rt-tabs--spacing-card': type === 'spacing-card',
          'el-tabs--spacing-card': type === 'spacing-card',
          'rt-tabs--button-card': type === 'button-card',
          'el-tabs--button-card': type === 'button-card',
          [`rt-tabs--${tabPosition}`]: true,
          [`el-tabs--${tabPosition}`]: true
        }}
      >
        {tabPosition !== 'bottom' ? [header, panels] : [panels, header]}
      </div>
    );
  }
};
</script>



// WEBPACK FOOTER //
// tabs.vue?5ac5a82a